export default __webpack_public_path__ + "static/media/ProximaNova-Thin.48a30ed4.woff2";